"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore since `createUseStyles` is missing type definitions
const react_jss_1 = require("react-jss");
// auto-install
const jss_1 = require("./jss");
jss_1.install();
function makeStyles(styles, options) {
    return react_jss_1.createUseStyles(styles, options);
}
exports.makeStyles = makeStyles;
